'use client';

import IcStarFull from '~/public/assets/icons/ic_star_fill.svg';
import IcStarHalf from '~/public/assets/icons/ic_star_fill_half.svg';
import IcStarEmpty from '~/public/assets/icons/ic_star_fill_empty.svg';

import styles from './ShopReviewsStarRating.module.css';
type Props = {
  grade: number;
};

const MAX_REVIEW_RATING = 5;
export const ShopReviewsStarRating = ({ grade }: Props) => {
  const roundedRating = Math.ceil(grade * 2) / 2;
  return (
    <div className={styles.container}>
      {Array.from({ length: MAX_REVIEW_RATING }).map((_, index) => {
        const rating = index + 1;

        if (rating <= roundedRating) {
          return <IcStarFull key={rating} />;
        }

        if (rating - 0.5 === roundedRating) {
          return <IcStarHalf key={rating} />;
        }

        return <IcStarEmpty key={rating} />;
      })}
    </div>
  );
};
